(() => {
  const key = 'oadg-saved-garments';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const refreshSaved = () => document.querySelectorAll('[data-oadg-save]').forEach(button => {
    const saved = read().includes(button.dataset.oadgSave);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', (saved ? 'Remove from saved garments: ' : 'Save garment: ') + button.dataset.oadgSave.replaceAll('-', ' '));
    button.querySelector('[aria-hidden]').textContent = saved ? '♥' : '♡';
  });
  function filter() {
    const form = document.querySelector('[data-oadg-filters]');
    if (!form) return;
    const values = new FormData(form); let visible = 0;
    document.querySelectorAll('#product-grid > [data-oadg-variants]').forEach(card => {
      const variants = JSON.parse(card.dataset.oadgVariants);
      const options = JSON.parse(card.dataset.oadgOptions).map(name => name.toLowerCase());
      const colourIndex = options.findIndex(name => name === 'color' || name === 'colour');
      const sizeIndex = options.indexOf('size');
      const matches = (!values.get('garment') || values.get('garment') === card.dataset.oadgGarment) &&
        (!values.get('saved') || read().includes(card.dataset.oadgHandle)) && variants.some(variant =>
          (!values.get('colour') || variant.options[colourIndex] === values.get('colour')) &&
          (!values.get('size') || variant.options[sizeIndex] === values.get('size')) &&
          (!values.get('price') || variant.price < Number(values.get('price'))));
      card.hidden = !matches; if (matches) visible++;
    });
    form.querySelector('[data-oadg-results]').textContent = visible + (visible === 1 ? ' garment' : ' garments');
    document.querySelector('[data-oadg-empty]').hidden = visible !== 0;
  }
  function initialize() {
    refreshSaved();
    const form = document.querySelector('[data-oadg-filters]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    const colours = new Set(), sizes = new Set();
    document.querySelectorAll('#product-grid > [data-oadg-variants]').forEach(card => {
      const options = JSON.parse(card.dataset.oadgOptions).map(name => name.toLowerCase());
      JSON.parse(card.dataset.oadgVariants).forEach(variant => {
        const colour = variant.options[options.findIndex(name => name === 'color' || name === 'colour')];
        const size = variant.options[options.indexOf('size')];
        if (colour) colours.add(colour); if (size) sizes.add(size);
      });
    });
    for (const [name, values] of [['colour', [...colours].sort()], ['size', [...sizes].sort((a,b) => ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'].indexOf(a)-['XS','S','M','L','XL','2XL','3XL','4XL','5XL'].indexOf(b))]]) {
      values.forEach(value => form.elements[name].add(new Option(value, value)));
    }
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', filter);
    form.addEventListener('reset', () => setTimeout(filter, 0));
    filter();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-oadg-save]');
    if (button) {
      const saved = read(), handle = button.dataset.oadgSave;
      try { localStorage.setItem(key, JSON.stringify(saved.includes(handle) ? saved.filter(item => item !== handle) : [...saved, handle])); } catch { return; }
      refreshSaved(); filter();
    }
    if (event.target.closest('[data-oadg-size-guide]')) {
      const guide = document.querySelector('.product__description table');
      if (guide) guide.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  });
  window.addEventListener('storage', () => { refreshSaved(); filter(); });
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('variant-selects, #ProductGridContainer') || node.querySelector('[data-oadg-filters]'))))) initialize();
  }).observe(document.body, {childList: true, subtree: true});
  initialize();
})();// Open the existing Judge.me review form from the product summary.
document.addEventListener('click', event => {
  if (!event.target.closest('[data-oadg-write-review]')) return;
  event.preventDefault(); event.stopImmediatePropagation();
  const reviews = document.querySelector('.jdgm-review-widget') || document.querySelector('#oadg-reviews');
  reviews?.scrollIntoView({behavior:'smooth',block:'start'});
  const write = reviews?.querySelector('.jdgm-write-rev-link') || [...(reviews?.querySelectorAll('button') || [])].find(button => button.textContent.trim() === 'Write a review');
  if (write) write.click();
});


document.addEventListener('click', event => { if(event.target.closest('.oadg-rating-summary a')) { event.preventDefault(); document.querySelector('.jdgm-review-widget')?.scrollIntoView({behavior:'smooth',block:'start'}); } });
document.addEventListener('click',event=>{
 const opener=event.target.closest('[data-oadg-guide-open]');
 if(opener){document.getElementById(opener.dataset.oadgGuideOpen)?.showModal();return;}
 const closer=event.target.closest('[data-oadg-guide-close]');if(closer){closer.closest('dialog').close();return;}
 const tab=event.target.closest('[data-oadg-guide-tab]');if(tab){const dialog=tab.closest('dialog');dialog.querySelectorAll('[data-oadg-guide-tab]').forEach(button=>button.setAttribute('aria-pressed',String(button===tab)));dialog.querySelectorAll('[data-oadg-guide-panel]').forEach(panel=>panel.hidden=panel.dataset.oadgGuidePanel!==tab.dataset.oadgGuideTab);}
});

// Colour thumbnails preview the actual variant without leaving the catalog.
document.addEventListener('click', event => {
  const bubble = event.target.closest('[data-oadg-colour-preview]');
  if (!bubble || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const card = bubble.closest('.product-card-wrapper');
  const image = card?.querySelector('.card__media img');
  if (!image) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  image.removeAttribute('srcset');
  image.src = bubble.dataset.oadgColourPreview;
  image.alt = bubble.dataset.oadgColourName + ' — ' + (card.querySelector('.card__heading')?.textContent.trim() || 'OADG garment');
  card.classList.add('oadg-colour-preview-active');
  card.querySelectorAll('.oadg-card-colour').forEach(option => option.removeAttribute('aria-current'));
  bubble.setAttribute('aria-current', 'true');
  card.querySelectorAll('.card__heading a').forEach(link => link.href = bubble.href);
});

// Keep reviews below the purchasing details on small screens.
(() => {
 const media = window.matchMedia('(min-width: 990px)');
 const placeReviews = () => {
  const reviews = document.getElementById('oadg-reviews');
  const product = reviews?.closest('product-info')?.querySelector('.product') || document.querySelector('product-info .product');
  if (!reviews || !product) return;
  if (media.matches) product.querySelector('.product__media-wrapper')?.append(reviews);
  else product.after(reviews);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',placeReviews);else placeReviews();
 media.addEventListener('change',placeReviews);
})();
